
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/great-place-to-work-rankings",
      function () {
        return require("private-next-pages/great-place-to-work-rankings/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/great-place-to-work-rankings"])
      });
    }
  